import { render, staticRenderFns } from "./form.vue?vue&type=template&id=d2c5ec0c"
import script from "./form.vue?vue&type=script&lang=ts"
export * from "./form.vue?vue&type=script&lang=ts"
import style0 from "./form.vue?vue&type=style&index=0&id=d2c5ec0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports